import { useGetProjects } from './useGetProjects'

/**
 * Hook to know if the workspace has a drafts project or not.
 * (Guest don't have any Drafts folder in the workspace by default)
 */
export default function useGetHasDraftsProject(workspaceId: string) {
  const data = useGetProjects({ workspaceId })

  const hasDraftsProject = Boolean(data.draftsProject?.entries[0])

  return hasDraftsProject
}
